// frontend/src/components/chatbot/ChatResponse.tsx
import React from 'react';
import FormattedText from './FormattedText';
import FollowUpButtons from './FollowUpButtons';

interface ChatResponseProps {
  content: string;
  query?: string;
  className?: string;
  showFollowUps?: boolean;
}

const ChatResponse: React.FC<ChatResponseProps> = ({
  content,
  query,
  className = 'chatbot-message-text',
  showFollowUps = true,
}) => {
  return (
    <div className={className}>
      <FormattedText text={content} />
      {showFollowUps && query && (
        <FollowUpButtons query={query} answer={content} />
      )}
    </div>
  );
};

export default ChatResponse;
